module.exports = __webpack_public_path__ + "media/images/pw.logo-131bf0ee.svg";